import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3450a374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications" }
const _hoisted_2 = { class: "message-header" }
const _hoisted_3 = { class: "message-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notific) => {
      return (_openBlock(), _createElementBlock("article", {
        key: notific.id,
        class: _normalizeClass(["message", `is-${notific.type}`])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(notific.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(notific.text), 1)
      ], 2))
    }), 128))
  ]))
}